import Vue from 'vue'
import VueRouter from 'vue-router'
import VueTagManager from 'vue-tag-manager'
import Vuelidate from 'vuelidate'
import './assets/scss/style.scss'
import App from './App.vue'

Vue.config.productionTip = false

Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'history'
})
Vue.use(VueTagManager, {
  gtmId: 'GTM-N3XRJHM'
})

Vue.use(Vuelidate)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
